import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';

export const ResultTile: StyleRule = () => ({
    height: pxToRem(58),
    width: '100%',
    padding: pxArrayToRem([9, 8]),
    cursor: 'pointer',
    [`&:hover`]: {
        background: `rgba(0, 0, 0, 0.06)`,
    },
});

export const ResultTileThumb: StyleRule<{
    logoBackground?: string;
}> = ({ theme, logoBackground }) => ({
    height: pxToRem(40),
    width: pxToRem(40),
    background: logoBackground ?? theme.siteVariables.colors.primitive.white,
    minWidth: pxToRem(40),
    position: 'relative',
});

export const ResultTileContent: StyleRule = () => ({
    justifyContent: 'center',
    maxWidth: pxToRem(282),
});

export const ResultTileTitle: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.charcoal['300'],
    fontWeight: theme.siteVariables.textStyles.Text.Medium65.fontWeight,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
});
export const ResultTileProfessional: StyleRule = ({ theme }) => ({
    color: theme.siteVariables.colors.grey['400'],
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    marginTop: pxToRem(2),
});
